import {
    DIC
} from '@/const/dic'
import {baseUrl} from '@/config/env';


export const engineeringOrderTableOption = {
    align: "center",
    menuAlign: "center",
    headerAlign: "center",
    border: true,
    // expand: false,
    stripe: false,
    showHeader: true,
    // align: 'center',
    index: false,
    selection: true,
    menu: true,
    page: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    viewBtn: false,
    menuWidth: '300',
    labelWidth: '120',
    expand: true,
    defaultSort:{
        prop: 'createTime',
        order: 'descending'
    },
    column: [
        {
            label: "工单编号",
            prop: "workOrderNum",
            type: "input",
            search: true,
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "预约人姓名",
            prop: "reservationName",
            type: "input",
            search: true
        },
        {
            label: "预约人电话",
            prop: "reservationMobile",
            type: "input",
            search: true
        },
        {
            label: "服务项目",
            prop: "serviceCategory",
            solt: true,
            formsolt: true
        },
        {
            label: "施工面积",
            prop: "constructionArea",
            sortable: true,
            type: "input"
        },
        {
            label: "工程总价",
            prop: "totalPrice",
            sortable: true,
            type: "input"
        },
        {
            label: "总服务费用",
            prop: "totalMoney",
            sortable: true,
            addVisdiplay: false,
            editVisdiplay: false,
            type: "input"
        },
        {
            label: "省",
            prop: "province",
            hide: true,
            formsolt: true
        },
        {
            label: "市",
            prop: "city",
            hide: true,
            formsolt: true
        },
        {
            label: "区",
            prop: "area",
            hide: true,
            formsolt: true
        },
        {
            label: "详细地址",
            prop: "address",
            hide: true,
            type: "input"
        },
        {
            label:"标记位置",
            prop:'provinces',
            hide: true,
            // span: 24,
            // solt: true,
            formsolt: true
        },
        // {
        //     // label:'省市区',
        //     prop:'provincesPoInt',
        //     // span: 24,
        //     component: "AvueMap"
        // },

        {
            label: "服务时间",
            prop: "serviceTime",
            type: "datetime",
            sortable: true,
            valueFormat: "timestamp",
            format: "yyyy-MM-dd HH:mm:ss",
            hide: true
        },

        {
            label: "地址",
            prop: "addressss",
            addVisdiplay: false,
            editVisdiplay: false,
            viewVisdiplay: false,
            formatter: function(row, value , label, column){
                return row.province + '-' + row.city + '-' + row.area + '-' + row.address
            }
        },
        {
            label: "规定工期",
            prop: "endTime",
            type: "datetime",
            sortable: true,
            valueFormat: "timestamp",
            format: "yyyy-MM-dd HH:mm:ss",
        },
        {
            label: "发布时间",
            prop: "createTime",
            type: "datetime",
            format: "yyyy-MM-dd HH:mm:ss",
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "详细工程单",
            prop: "childList",
            span: 24,
            hide: true,
            solt: true,
            formsolt: true
        },
        // {
        //     label: "创建人",
        //     prop: "createBy",
        //     type: "input",
        //     hidden: true,
        //     addVisdiplay: false,
        //     editVisdiplay: false
        // },
        // {
        //     label: "状态",
        //     prop: "status",
        //     type: "radio",
        //     addVisdiplay: false,
        //     editVisdiplay: false,
        //     solt: true
        // },
        {
            label: "更新时间",
            prop: "updateTime",
            type: "datetime",
            format: "yyyy-MM-dd HH:mm:ss",
            hide: true,
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "更新人",
            prop: "updateBy",
            type: "input",
            hide: true,
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "是否删除",
            prop: "deleteFlag",
            type: "radio",
            hide: true,
            addVisdiplay: false,
            editVisdiplay: false,
            dicData: DIC.DELETE_FLAG
        },
        {
            label: "备注",
            prop: "remarks",
            type: "textarea",
            hide: true,
            span: 24,
            max: 255
        }
    ]
};